import React, { useState } from 'react';
import UKflag from '../../images/svg-gcbooks/ukflag.png';
import USflag from '../../images/svg-gcbooks/usflag.png';
import AUSflag from '../../images/svg-gcbooks/ausflag.jpg';
import { useBookAudioPlayer } from '../../context/bookAudioPlayerContext';
import './voiceSelector.scss';

export default function VoiceSelector({ color, stroke }) {
  const [isOpen, setIsOpen] = useState(false);
  const { selectedVoice, setSelectedVoice } = useBookAudioPlayer();

  const voices = [
    {
      category: 'Modern',
      name: 'Charlene',
      flag: UKflag,
    },
    {
      category: 'Original',
      name: 'Callie',
      flag: USflag,
    },
    {
      category: 'Dramatized',
      name: 'Nancy',
      flag: AUSflag,
    },
  ];

  const handleSelectVoice = (voiceName) => {
    setSelectedVoice(voiceName);
    setIsOpen(false);
  };

  const currentVoice = voices.find((v) => v.name === selectedVoice) || voices[0];

  return (
    <div className="voice-dropdown-container">
      <button className="dropdown-header" onClick={() => setIsOpen(!isOpen)}>
        <div className="selected-voice">
          <div className="flag">
            <img src={currentVoice.flag} className="flag-img" alt={`${currentVoice.name} flag`} />
          </div>
          <span style={{ color: color }}>{selectedVoice || 'Charlene'}</span>
        </div>
        <svg className={`chevron ${isOpen ? 'open' : ''}`} width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M5 7.5L10 12.5L15 7.5"
            stroke={stroke}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="dropdown-menu">
          {voices.map((voice, index) => (
            <div key={voice.name}>
              {(index === 0 || voices[index - 1].category !== voice.category) && (
                <div className="category-label">{voice.category}</div>
              )}
              <button className="voice-option" onClick={() => handleSelectVoice(voice.name)}>
                <div className="flag">
                  <img src={voice.flag} className="flag-img" alt={`${voice.name} flag`} />
                </div>
                <span className="voice-name">{voice.name}</span>
                <div className={`radio-button ${selectedVoice === voice.name ? 'selected' : ''}`}>
                  {selectedVoice === voice.name && <div className="radio-dot"></div>}
                </div>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
